import React, { useRef, useState } from "react";
import {
  X,
  Folder,
  File as FileIcon,
  ChevronUp,
  ChevronDown,
  Trash2,
  FolderTree,
  Loader2,
} from "lucide-react";

import changeStatusIcon from "../../../assets/icons/changeStatusIcon.png";
import { decodeUtf8Mojibake } from "../../../utils/filenameEncoding";
import fileIcon from "../../../assets/UserIcons/FileIcon.svg";
export function RepoModals({
  deleteModal,
  onCloseDeleteModal,
  onDelete,
  moveModal,
  onCloseMoveModal,
  onSelectMoveFolder,
  onConfirmMove,
  items,
  repoView,
  createFolderModal,
  onCloseCreateFolderModal,
  onCreateFolderNameChange,
  onCreateFolder,
  showFirstModal,
  onCloseFirstModal,
  uploadMode,
  onUploadModeSelect,
  onContinueToTraining,
  showTrainingModal,
  onCloseTrainingModal,
  isTraining,
  onSendForTraining,
  showSummaryModal,
  onCloseSummaryModal,
  showRenameModal,
  renameTarget,
  renameText,
  onRenameTextChange,
  onCloseRenameModal,
  onRename,
  isRenaming,
  dataName,
  onDataNameChange,
  showUploadModeDropdown,
  onToggleUploadModeDropdown,
  summaryDataList,
  onUploadToBackend,
  isSubmitting,
}) {
  const dropdownRef = useRef(null);
  const [isCreating, setIsCreating] = useState(false);

  const handleCreateFolderInternal = () => {
    try {
      const result = onCreateFolder && onCreateFolder();
      if (result && typeof result.then === "function") {
        setIsCreating(true);
        result.finally(() => setIsCreating(false));
      }
    } catch (err) {
      setIsCreating(false);
      throw err;
    }
  };
  const renderModalShell = ({ onClose, maxWidth, children }) => (
    <div
      className="modal modal-backdrop-custom d-block"
      tabIndex="-1"
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="document-modal modal-content text-center"
          style={maxWidth ? { maxWidth, width: "90%" } : undefined}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {deleteModal.show &&
        renderModalShell({
          onClose: onCloseDeleteModal,
          maxWidth: "450px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative p-0">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseDeleteModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding">
                {deleteModal.items.length === 1 &&
                deleteModal.items[0].type === "folder" ? (
                  <>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
                        <Trash2
                          size={36}
                          className="text-danger"
                          style={{ cursor: "pointer" }}
                          title="Delete"
                        />
                      </div>
                    </div>
                    <h5 className="fw-semibold mb-2">Delete Folder</h5>
                    <p className="mb-0">
                      Are you sure you want to delete{" "}
                      <strong>{deleteModal.items[0].name}</strong> and all its
                      contents?
                    </p>
                  </>
                ) : (
                  <>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
                        <Trash2
                          size={36}
                          className="text-danger"
                          style={{ cursor: "pointer" }}
                          title="Delete"
                        />
                      </div>
                    </div>
                    <h5 className="fw-semibold mb-3">
                      Delete{" "}
                      {deleteModal.items.length > 1
                        ? `${deleteModal.items.length} Items`
                        : deleteModal.items[0]?.type === "folder"
                          ? "Folder"
                          : "File"}
                    </h5>
                    <p className="mb-0">
                      Are you sure you want to delete{" "}
                      <strong>
                        {deleteModal.items.length > 1
                          ? `${deleteModal.items.length} selected items`
                          : deleteModal.items[0]?.name}
                      </strong>
                      ?
                    </p>
                  </>
                )}
              </div>

              <div className="modal-footer justify-content-center gap-3">
                <button
                  className="cancle-btn w-25 border border-1 fw-semibold"
                  onClick={onCloseDeleteModal}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  onClick={() => onDelete("DELETE")}
                >
                  {deleteModal.items.length > 1 ? "Delete" : "Delete"}
                </button>
              </div>
            </>
          ),
        })}

      {/* Move Modal */}
      {moveModal.show &&
        renderModalShell({
          onClose: onCloseMoveModal,
          maxWidth: "500px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative p-0">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseMoveModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding">
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
                    <FolderTree
                      size={36}
                      className="text-black"
                      style={{ cursor: "pointer" }}
                      title="Move"
                    />
                  </div>
                </div>
                <h5 className="fw-semibold mb-2">
                  Move{" "}
                  {moveModal.items.length === 1
                    ? "Item"
                    : `${moveModal.items.length} Items`}
                </h5>
                <p className="mb-2">
                  Select destination folder for{" "}
                  <strong>
                    {moveModal.items.length === 1
                      ? moveModal.items[0].name
                      : "selected items"}
                  </strong>
                </p>

                <div className="repo-folder-tree custom-ak-scollbar">
                  {/* In Group Repository, items must stay within the same group */}
                  {repoView === "group" && (
                    <div
                      style={{
                        fontSize: "0.78rem",
                        color: "var(--repo-text-muted, #888)",
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <FolderTree size={13} />
                      Files can only be moved within the same group.
                    </div>
                  )}

                  {/* Root Directory option — hidden in Group Repository (groups are root) */}
                  {repoView !== "group" && (
                    <div
                      className={`repo-folder-option ${moveModal.targetFolderId === null ? "selected" : ""}`}
                      onClick={() => onSelectMoveFolder(null)}
                    >
                      <Folder size={16} /> Root Directory
                    </div>
                  )}

                  {/* Recursive folder render */}
                  {(() => {
                    // Determine the groupId of the items being moved (first item's groupId)
                    const movingGroupId =
                      repoView === "group" && moveModal.items.length > 0
                        ? moveModal.items[0].groupId
                        : null;
                    const groupRootParentId =
                      repoView === "group" && movingGroupId
                        ? `group-${movingGroupId}`
                        : null;

                    const renderFolders = (parentId = null, depth = 0) => {
                      const folders = items
                        .filter((i) => {
                          if (
                            i.type !== "folder" ||
                            i.parentId !== parentId ||
                            moveModal.items.some((mi) => mi.id === i.id)
                          )
                            return false;

                          if (repoView === "personal_space") {
                            return i.isPersonalSpace === true;
                          }
                          if (repoView === "global") {
                            return (
                              i.mode === "global" ||
                              (i.ownerType === "admin" &&
                                i.mode !== "group" &&
                                !i.groupId &&
                                !i.departmentId)
                            );
                          }
                          if (repoView === "personal") {
                            return (
                              !i.isPersonalSpace &&
                              i.ownerType !== "admin" &&
                              i.mode !== "global" &&
                              i.mode !== "group"
                            );
                          }
                          // Group Repository: only show folders in the same group
                          // and exclude group root folders (cannot move into a group root)
                          if (repoView === "group") {
                            return (
                              i.mode === "group" &&
                              !i.isGroupRoot &&
                              String(i.groupId) === String(movingGroupId)
                            );
                          }
                          return false;
                        })
                        .sort((a, b) => a.name.localeCompare(b.name));
                      return folders.map((f) => (
                        <React.Fragment key={f.id}>
                          <div
                            className={`repo-folder-option ${moveModal.targetFolderId === f.id ? "selected" : ""}`}
                            style={{
                              paddingLeft: `${(depth + 1) * 20 + 12}px`,
                            }}
                            onClick={() => onSelectMoveFolder(f.id)}
                          >
                            <Folder size={16} />{" "}
                            {f.name.charAt(0).toUpperCase() + f.name.slice(1)}
                          </div>
                          {renderFolders(f.id, depth + 1)}
                        </React.Fragment>
                      ));
                    };
                    return renderFolders(groupRootParentId, 0);
                  })()}
                </div>
              </div>

              <div className="modal-footer justify-content-center  gap-3">
                <button
                  className="cancle-btn w-25 border border-1 fw-semibold"
                  onClick={onCloseMoveModal}
                >
                  Cancel
                </button>
                <button className="custom-btn w-25" onClick={onConfirmMove}>
                  Save
                </button>
              </div>
            </>
          ),
        })}

      {/* New Folder Modal */}
      {createFolderModal.show &&
        renderModalShell({
          onClose: onCloseCreateFolderModal,
          maxWidth: "400px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative p-0">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseCreateFolderModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding">
                <h5 className="fw-semibold mb-2">New Folder</h5>
                <input
                  type="text"
                  className="repo-search-input w-100"
                  placeholder="Folder Name"
                  autoFocus
                  value={createFolderModal.name}
                  onChange={(e) => onCreateFolderNameChange(e.target.value)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && handleCreateFolderInternal()
                  }
                />
              </div>

              <div className="modal-footer justify-content-center gap-3">
                <button
                  className="repo-btn repo-btn-primary d-flex align-items-center justify-content-center"
                  onClick={handleCreateFolderInternal}
                  disabled={isCreating}
                  aria-disabled={isCreating}
                >
                  {isCreating ? (
                    <>
                      <Loader2 className="animate-spin me-2" size={16} />
                      Creating...
                    </>
                  ) : (
                    "Create Folder"
                  )}
                </button>
              </div>
            </>
          ),
        })}

      {/* Rename Folder Modal */}
      {showRenameModal &&
        renameTarget &&
        renderModalShell({
          onClose: onCloseRenameModal,
          maxWidth: "400px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative p-0">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseRenameModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding">
                <h5 className="fw-semibold mb-2">Rename Item</h5>
                <input
                  type="text"
                  className="repo-search-input w-100"
                  placeholder={`New ${renameTarget.type === "folder" ? "Folder" : "File"} Name`}
                  autoFocus
                  value={renameText}
                  onChange={(e) => onRenameTextChange(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && onRename()}
                />
              </div>

              <div className="modal-footer justify-content-center gap-3">
                <button
                  className="cancle-btn w-25 border border-1 fw-semibold"
                  onClick={onCloseRenameModal}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  onClick={onRename}
                  disabled={isRenaming}
                  aria-disabled={isRenaming}
                >
                  {isRenaming ? (
                    <>
                      <Loader2 className="animate-spin me-2" size={16} />
                      Renaming...
                    </>
                  ) : (
                    "Rename"
                  )}
                </button>
              </div>
            </>
          ),
        })}

      {/* Mode Selection Modal (First Modal) */}
      {showFirstModal &&
        renderModalShell({
          onClose: onCloseFirstModal,
          maxWidth: "450px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseFirstModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "rgba(255,255,255,0.1)",
                    }}
                  >
                    <FileIcon size={30} />
                  </div>
                </div>

                <p className="mb-2">
                  You have uploaded document. You are currently in{" "}
                  <strong>{uploadMode} Mode</strong>.
                </p>
                <p className="mb-4">You can change the mode below if needed:</p>

                <div className="d-flex justify-content-center gap-4 mb-4">
                  {["Global", "Personal"].map((mode) => (
                    <label
                      key={mode}
                      className="repo-radio-label"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="radio"
                        name="uploadMode"
                        value={mode}
                        checked={uploadMode === mode}
                        onChange={() => onUploadModeSelect(mode)}
                        style={{ marginRight: "8px" }}
                      />
                      {mode}
                    </label>
                  ))}
                </div>
              </div>

              <div className="modal-footer justify-content-center gap-3">
                <button
                  className="cancle-btn w-25 border border-1 fw-semibold"
                  onClick={onCloseFirstModal}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  onClick={onContinueToTraining}
                >
                  Continue
                </button>
              </div>
            </>
          ),
        })}

      {/* Training Confirmation Modal */}
      {showTrainingModal &&
        renderModalShell({
          onClose: onCloseTrainingModal,
          maxWidth: "450px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseTrainingModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                    }}
                  >
                    <img
                      src={changeStatusIcon}
                      alt="Training"
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                </div>

                <p className="fw-bold mb-0">
                  Are you sure you want to send this document for training?
                </p>
              </div>

              <div className="modal-footer justify-content-center gap-3">
                <button
                  className="cancle-btn w-25 border border-1 fw-semibold"
                  disabled={isTraining}
                  onClick={onCloseTrainingModal}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  disabled={isTraining}
                  onClick={onSendForTraining}
                >
                  {isTraining ? "Sending..." : "Send"}
                </button>
              </div>
            </>
          ),
        })}

      {/* Summary Review Modal */}
      {showSummaryModal &&
        renderModalShell({
          onClose: onCloseSummaryModal,
          maxWidth: "800px",
          children: (
            <>
              <div className="modal-header justify-content-center position-relative">
                <button
                  type="button"
                  className="modal-close-btn position-absolute"
                  aria-label="Close"
                  onClick={onCloseSummaryModal}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-body modal-body-padding text-center">
                <h5 className="fw-semibold mb-4">Review Summaries</h5>

                <div className="row mb-4">
                  <div className="col-md-6 text-start">
                    <label className="repo-filter-label">Data Name</label>
                    <input
                      type="text"
                      className="repo-search-input w-100"
                      placeholder="Enter Data Name"
                      value={dataName}
                      onChange={(e) => onDataNameChange(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 text-start">
                    <label className="repo-filter-label">Upload Mode</label>
                    <div className="dropdown w-100" ref={dropdownRef}>
                      <button
                        type="button"
                        className="repo-search-input w-100 text-start d-flex justify-content-between align-items-center"
                        onClick={onToggleUploadModeDropdown}
                      >
                        {uploadMode}
                        {showUploadModeDropdown ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </button>
                      {showUploadModeDropdown && (
                        <div className="dropdown-menu show w-100 shadow-lg border-0 bg-dark text-white">
                          {["Global", "Personal"].map((mode) => (
                            <button
                              key={mode}
                              className="dropdown-item text-white"
                              onClick={() => onUploadModeSelect(mode)}
                            >
                              {mode}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="repo-summary-list"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {summaryDataList.map((item, index) => (
                    <div
                      key={index}
                      className="repo-summary-card p-3 mb-3"
                      style={{
                        background: "rgba(255,255,255,0.05)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <FileIcon size={18} />
                        <strong>{decodeUtf8Mojibake(item.filename)}</strong>
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.9rem" }}
                      >
                        {item.summary || "No summary available."}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-footer justify-content-center gap-3 mt-4">
                <button className="repo-btn" onClick={onCloseSummaryModal}>
                  Cancel
                </button>
                <button
                  className="repo-btn repo-btn-primary"
                  onClick={onUploadToBackend}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Complete Training"}
                </button>
              </div>
            </>
          ),
        })}
    </>
  );
}
